module.exports = ".modal-body p {\n  font-size: 14px; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/lead-sources-section/modals/delete-lead-source-modal/delete-lead-source-modal.component.scss
// module id = ./web/modern/components/settings/lead-sources-section/modals/delete-lead-source-modal/delete-lead-source-modal.component.scss
// module chunks = 0